var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNegativeInformation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7656 16.4062H28.5938V17.5H29.7656V16.4062Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7656 18.4375H28.5938V19.5312H29.7656V18.4375Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7656 14.4531H28.5938V15.5469H29.7656V14.4531Z",
    fill: "#666666"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0625 12.5781H22.9687V29.2188H20.3906L26.25 35.0781L32.0312 29.2188H29.6875V20.3906H28.5937V29.2188H26.5625V30.3906H29.2969L26.25 33.4375L23.125 30.3906H24.0625V12.5781Z",
    fill: "#666666"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3594 16.4062H17.1875V17.5H18.3594V16.4062Z",
    fill: "#666666"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3594 18.4375H17.1875V19.5312H18.3594V18.4375Z",
    fill: "#666666"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3594 14.4531H17.1875V15.5469H18.3594V14.4531Z",
    fill: "#666666"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1562 34.9219V36.0938H17.8906L14.8438 39.1406L11.7969 36.0938H12.7344V12.5781H11.5625V34.9219H8.98438L14.8438 40.7031L20.7031 34.9219H18.3594V22.4219H17.1875V34.9219H15.1562Z",
    fill: "#666666"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0938 16.4062H39.9219V17.5H41.0938V16.4062Z",
    fill: "#666666"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0938 14.4531H39.9219V15.5469H41.0938V14.4531Z",
    fill: "#666666"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4688 12.5781H34.2969V23.5938H31.7969L37.5781 29.375L43.4375 23.5938H41.0937V18.4375H39.9219V23.5938H37.8906V24.7656H40.625L37.5781 27.8125L34.5312 24.7656H35.4688V12.5781Z",
    fill: "#666666"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3594 20.3906H17.1875V21.4844H18.3594V20.3906Z",
    fill: "#666666"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25 48.3594C38.9844 48.3594 50 43.4375 50 37.0313C50 33.6719 46.7188 30.4688 41.0156 28.3594L40.625 29.4531C45.8594 31.4063 48.8281 34.2188 48.8281 37.1094C48.8281 42.5781 37.8906 47.2656 25 47.2656C12.0312 47.2656 1.17188 42.6563 1.17188 37.1094C1.17188 34.2188 4.14062 31.4063 9.375 29.4531L8.98438 28.3594C3.28125 30.4688 0 33.6719 0 37.0313C0 43.3594 11.0156 48.3594 25 48.3594Z",
    fill: "#666666"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2656 42.5L41.7969 41.4844C41.4844 41.6406 41.1719 41.7969 40.8594 41.9531L41.0156 42.5L41.3281 42.9688C41.5625 42.8125 41.9531 42.6563 42.2656 42.5Z",
    fill: "#666666"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5156 43.9063C38.9062 43.75 39.2969 43.6719 39.6094 43.5156L39.2188 42.4219C38.9063 42.5781 38.5156 42.6562 38.125 42.8125L38.5156 43.9063Z",
    fill: "#666666"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9844 40.0781C43.6719 40.3125 43.3594 40.4687 43.0469 40.7031L43.6719 41.7188C44.0625 41.4844 44.375 41.25 44.6875 41.0937L43.9844 40.0781Z",
    fill: "#666666"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8594 44.6094C36.25 44.5312 36.6406 44.4531 36.9531 44.2969L36.6406 43.2031C36.25 43.2812 35.9375 43.3594 35.5469 43.4375L35.8594 44.6094Z",
    fill: "#666666"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9844 1.64062H32.8125V2.8125H33.9844V1.64062Z",
    fill: "#666666"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1094 1.64062H15.9375V2.8125H17.1094V1.64062Z",
    fill: "#666666"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3594 1.64062H27.1875V2.8125H28.3594V1.64062Z",
    fill: "#666666"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5469 1.64062H24.375V2.8125H25.5469V1.64062Z",
    fill: "#666666"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1719 1.64062H30V2.8125H31.1719V1.64062Z",
    fill: "#666666"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7344 1.64062H21.5625V2.8125H22.7344V1.64062Z",
    fill: "#666666"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9219 1.64062H18.75V2.8125H19.9219V1.64062Z",
    fill: "#666666"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M36.25 2.8125H47.0313V1.64062H36.25H36.0156H35.625V2.8125H36.0156H36.25Z",
    fill: "#666666"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9844 2.8125H14.375V1.64062H13.9844H13.75H2.96875V2.8125H13.75H13.9844Z",
    fill: "#666666"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3438 5.78125H36.1719V6.95312H37.3438V5.78125Z",
    fill: "#666666"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0781 5.78125H38.9062V6.95312H40.0781V5.78125Z",
    fill: "#666666"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6875 5.78125H33.5156V6.95312H34.6875V5.78125Z",
    fill: "#666666"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0156 5.78125H14.8438V6.95312H16.0156V5.78125Z",
    fill: "#666666"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6719 5.78125H17.5V6.95312H18.6719V5.78125Z",
    fill: "#666666"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 5.78125H9.45312V6.95312H10.625V5.78125Z",
    fill: "#666666"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3594 5.78125H12.1875V6.95312H13.3594V5.78125Z",
    fill: "#666666"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3281 5.78125H20.1562V6.95312H21.3281V5.78125Z",
    fill: "#666666"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M29.375 5.78125H28.2031V6.95312H29.375V5.78125Z",
    fill: "#666666"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9844 5.78125H22.8125V6.95312H23.9844V5.78125Z",
    fill: "#666666"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0312 5.78125H30.8594V6.95312H32.0312V5.78125Z",
    fill: "#666666"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7188 5.78125H25.5469V6.95312H26.7188V5.78125Z",
    fill: "#666666"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNegativeInformation);
export default __webpack_public_path__ + "static/media/negativeInformation.7065a647aaa456fc8e43de67d7de6be2.svg";
export { ForwardRef as ReactComponent };